"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactUi = require("@100mslive/react-ui");
var _reactRouterDom = require("react-router-dom");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function ErrorPage(_ref) {
  var error = _ref.error;
  var _useParams = (0, _reactRouterDom.useParams)(),
    sessionId = _useParams.sessionId;
  var themeType = (0, _reactUi.useTheme)().themeType;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Flex, {
    align: "center",
    justify: "center",
    css: {
      size: "100%",
      color: "$textPrimary",
      backgroundColor: "$bgPrimary"
    },
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Box, {
      css: {
        position: "relative",
        overflow: "hidden",
        r: "$3",
        size: "100%"
      },
      children: window.location.hostname === "localhost" ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Flex, {
        align: "center",
        direction: "column",
        css: {
          position: "absolute",
          size: "100%",
          top: "33.33%",
          left: 0
        },
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Text, {
          variant: "h3",
          children: "Something went wrong!"
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Text, {
          variant: "body1",
          css: {
            margin: "1.75rem",
            textAlign: "center"
          },
          children: ["The meeting URL does not exist. If think this is an error on our side, please reach out to AstroG support.", /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactRouterDom.Link, {
            to: "/consultation/".concat(sessionId),
            children: "Click here"
          }), " ", "to try to join the meet again"]
        })]
      }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Flex, {
        align: "center",
        direction: "column",
        css: {
          position: "absolute",
          size: "100%",
          top: "33.33%",
          left: 0
        },
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Text, {
          variant: "h2",
          children: "404"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Text, {
          variant: "h4",
          css: {
            mt: "1.75rem"
          },
          children: error
        })]
      })
    })
  });
}
ErrorPage.displayName = "ErrorPage";
var _default = ErrorPage;
exports["default"] = _default;